import { createStandaloneToast } from '@chakra-ui/react';
import axios from 'axios';
import { object, string } from 'yup';
import { ERROR_MESSAGES } from '@lon/shared/constants';
import { getLastDistrictBySignature } from '@lon/shared/utils';
import {
  ErrorResponse,
  LoginState,
  OnSubmitProps,
  SuccessResponse,
} from './types';

export const getValidation = (isMFARequired?: boolean) => {
  const validationSchema = object({
    username: string()
      .trim()
      .required('Username is a required field')
      .default(''),
    password: string()
      .trim()
      .required('Password is a required field')
      .default(''),
    ...(isMFARequired && {
      mfaCode: string()
        .trim()
        .required('"Verification Code" is a required field'),
    }),
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({}),
  };
};

export const onSubmit = async ({
  password,
  username,
  mfaCode,
  isMFA,
  onSuccess,
  setLoginState,
}: OnSubmitProps) => {
  const district = getLastDistrictBySignature();

  try {
    await axios.post<SuccessResponse>(
      `${process.env.NX_REACT_APP_LOGIN_API}${isMFA ? '/mfa' : ''}`,
      new URLSearchParams({
        username,
        password,
        district: district?.value,
        ...(mfaCode && { code: mfaCode }),
      })
    );

    onSuccess();
  } catch (error) {
    const { toast } = createStandaloneToast();

    if (axios.isAxiosError(error) && error.response) {
      const backendError = error as ErrorResponse;

      if (error.response.status < 500 && error.response.status !== 0) {
        const { code = 'GENERAL_ERROR' } =
          backendError?.response?.data.error || {};

        if (code === 'MFA_CODE_REQUIRED') {
          setLoginState(LoginState.MFA);
          return;
        } else {
          const message = ERROR_MESSAGES[code];
          toast({ title: message.trim(), status: 'error', isClosable: true });
          return;
        }
      }
    }
    toast({
      title: ERROR_MESSAGES.GENERAL_ERROR,
      status: 'error',
      isClosable: true,
    });
  }
};
